import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';
import { FilterOperationType, type IFilter } from '@chax-at/prisma-filter-common';
import type { ICompetenceAssessmentFilter } from 'common/interface/filter.interface';

export async function fetchCompetenceAssessmentsAdmin(): Promise<Components.Schemas.CompetenceAssessmentDto[]> {
  const filter: IFilter<ICompetenceAssessmentFilter> = {
    filter: [{ field: 'isTemplate', type: FilterOperationType.Eq, value: true }],
    order: [{ field: 'schoolLevel', dir: 'asc' }],
  };

  const res = await Api.Routes.CompetenceAssessment.retrieve({ $filter: filter });
  return res.rows;
}

export async function fetchCompetenceAssessmentsTeacher(params: {
  classId: number;
}): Promise<Components.Schemas.CompetenceAssessmentDto[]> {
  const filter: IFilter<ICompetenceAssessmentFilter> = {
    filter: [
      { field: 'isTemplate', type: FilterOperationType.Eq, value: false },
      { field: 'schoolClassId', type: FilterOperationType.Eq, value: params.classId },
    ],
    order: [{ field: 'schoolLevel', dir: 'asc' }],
  };

  const res = await Api.Routes.CompetenceAssessment.retrieve({ $filter: filter });
  return res.rows;
}

export async function changeCompetenceAssessmentVisual(params: {
  competenceAssessmentId: number;
  dto: Components.Schemas.ChangeCompetenceAssessmentVisualDto;
}): Promise<void> {
  await Api.Routes.CompetenceAssessment.changeVisual({ id: params.competenceAssessmentId }, params.dto);
}

export async function updateCompetenceAssessmentVisualAndLevelTexts(params: {
  competenceAssessmentId: number;
  dto: Components.Schemas.UpdateCompetenceAssessmentConfigurationDto;
}): Promise<Components.Schemas.CompetenceAssessmentDto> {
  const response = await Api.Routes.CompetenceAssessment.updateVisualAndLevelTexts(
    { id: params.competenceAssessmentId },
    params.dto,
  );
  return response.data;
}
